import { tallyTokens } from "../../theme.tsx";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Badge } from "@mui/material";
import { NotificationsBellIcon } from "../icons/DrawerNavIcons.tsx";
import DrawerNavRow from "../conversation/DrawerNavRow.tsx";
import { fetchNotifications } from "../../store/notifications.tsx";
import { conversationActions } from "../../store/conversation.tsx";
import type { RootState } from "../../store/types.tsx";
import { Trans } from "@lingui/react/macro";

interface NotificationsDrawerActionProps {
  closeDrawer: () => void;
  onConversationSelected?: () => void;
  active?: boolean;
}

const NotificationsDrawerAction: React.FC<NotificationsDrawerActionProps> = ({
  closeDrawer,
  onConversationSelected,
  active = false,
}) => {
  const dispatch = useDispatch();

  const notifications = useSelector((state: RootState) => state.notifications);
  const unreadCount = notifications.allIds.filter(
    (id) => !notifications.byId[id]?.read,
  ).length;

  useEffect(() => {
    dispatch(fetchNotifications() as any);
  }, [dispatch]);

  const handleOpenNotifications = () => {
    closeDrawer();
    dispatch(conversationActions.setSelectedView("notifications"));
    onConversationSelected?.();
  };

  return (
    <DrawerNavRow
      onClick={handleOpenNotifications}
      active={active}
      icon={
        <Badge
          badgeContent={unreadCount}
          variant="dot"
          sx={{
            "& .MuiBadge-badge": {
              backgroundColor: tallyTokens.brand,
            },
          }}
        >
          <NotificationsBellIcon />
        </Badge>
      }
      label={
        <Trans context={"Span next to a button serving as a button title"}>
          Notifications
        </Trans>
      }
    />
  );
};

export default NotificationsDrawerAction;
